import React, { useState } from "react";
import "./pop.css";
import playStoreImg from "../assets/googleplay.png"; // image path

export default function FreeShippingPopup() {
  const [showShipping, setShowShipping] = useState(true);
  const [showAndroid, setShowAndroid] = useState(true);

  return (
    <>
      {/* ANDROID APP POPUP (TOP) */}
      {showAndroid && (
        <div className="free-shipping-popup android-popup">
          <a
            href="https://play.google.com/store/apps/details?id=com.sangitnew"
            target="_blank"
            rel="noopener noreferrer"
            className="popup-link"
          >
            <img
              src={playStoreImg}
              alt="Android App"
              className="popup-image"
            />
            Android App
          </a>
          <button
            className="close-btn"
            onClick={() => setShowAndroid(false)}
          >
            ×
          </button>
        </div>
      )}

      {/* FREE SHIPPING POPUP (BOTTOM) */}
      {showShipping && (
        <div className="free-shipping-popup shipping-popup">
          🚚 Free Shipping
          <button
            className="close-btn"
            onClick={() => setShowShipping(false)}
          >
            ×
          </button>
        </div>
      )}
    </>
  );
}
